// extracted by mini-css-extract-plugin
module.exports = {"botVariantIndicator":"styles_botVariantIndicator__3DNMk","botVariantIndicatorB":"styles_botVariantIndicatorB__1K_PW"};